module.exports = {
	REQUEST_TRIALS: "REQUEST_TRIALS",
	RECEIVE_TRIALS: "RECEIVE_TRIALS",
  REQUEST_TRIALS_ERROR: "REQUEST_TRIALS_ERROR",
};



// WEBPACK FOOTER //
// ./src/common/modules/trials/constants.js